import { render, staticRenderFns } from "./PaddyFieldAdd.vue?vue&type=template&id=63fa1459&"
import script from "./PaddyFieldAdd.vue?vue&type=script&lang=js&"
export * from "./PaddyFieldAdd.vue?vue&type=script&lang=js&"
import style0 from "./PaddyFieldAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports